import { render } from "./SummaryCard.vue?vue&type=template&id=25be1944"
import script from "./SummaryCard.vue?vue&type=script&lang=js"
export * from "./SummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__